import { Component, Input, SimpleChanges } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-alert-f29',
  templateUrl: './alert-f29.component.html',
  styleUrls: ['./alert-f29.component.scss']
})
export class AlertF29Component {
  @Input() reportesPrincipalesObj: any = {};
  @Input() addCarpeta: boolean = false;
  @Input() addHistorico: boolean = false;
  @Input() addCalculado: boolean = false;

  public listSoloFolio: {periodo: number, mes: number, displayMes: string, date: string}[] = [];
  public mostrarDetalle: boolean = false;

  constructor(private utilsService: UtilsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reportesPrincipalesObj'] && this.reportesPrincipalesObj && Object.keys(this.reportesPrincipalesObj).length > 0) {
      this.validarF29();
    }
  }

  private validarF29(): void {
    const F29Limpio = this.utilsService.obtenerDatosF29(this.reportesPrincipalesObj, this.addCarpeta, this.addHistorico, this.addCalculado) || [];

    if (!F29Limpio || F29Limpio.length <= 0) {
      return;
    }

    this.listSoloFolio = this.utilsService.getSoloFolioF29(F29Limpio)
  }
}
